import React from "react";
import { useEffect, useState } from "react";

async function getQuestions(token, examId, answers) {
  console.log("Started");
  return fetch("https://project-x-01.herokuapp.com/user/submit/" + examId, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(answers),
  }).then((data) => data.json());
}

function End({token, examId, results, data, onReset, onAnswersCheck, time, setCorrect }) {
  const [correctAnswers, setCorrectAnswers] = useState(0);
  useEffect(() => {
    getRes();
  }, []);

  async function getRes() {
    let a = [];
    results.forEach((result, index) => {
      a.push(result.a);
    });
    const ans = await getQuestions(token, examId, { answers: a });

    setCorrectAnswers(ans.marks);
    setCorrect(ans.correctAnswers);
  }

  return (
    <div className="card">
      <div className="card-content">
        <div className="content">
          <h3>Your Results</h3>
          <p>
            {correctAnswers} of {data.length}
          </p>
          <p>
            <strong>{Math.floor((correctAnswers / data.length) * 100)}%</strong>
          </p>
          <p>
            <strong>Your Time:</strong> {time}s
          </p>
          <button className="button is-info mr-2" onClick={onAnswersCheck}>
            Check Answers
          </button>
          <button className="button is-success mr-2" onClick={onReset}>
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
}

export default End;
